import React from "react";
import BtnOLevel from "../../buttons/BtnOLevel";
import { useQuery } from "@tanstack/react-query";
import { axiosget } from "../../helpers/httprequest";
import Loader from "../../components/Loader";
import ErrorResponse from "../../components/ErrorResponse";
import BtnDeleteOLevel from "../../buttons/BtnDeleteOLevel";
import moment from "../../helpers/moment";
import PageTitle from "../../components/PageTitle";

const OLevel = () => {
  const { isLoading, error, data } = useQuery({
    queryKey: ["oLevelSitting"],
    queryFn: async () => {
      const req = await axiosget("ms_applicant_sitting");
      return req?.data;
    },
  });
  return (
    <>
      <PageTitle title={`Examination Sittings`} sub={`Applicant can use combination of two results to secure an admission`} />
      {isLoading ? (
        <Loader />
      ) : (
        <div className="row">
          {error && <ErrorResponse type={"danger"} message={"Sorry, system could not find data"} />}
          {!error && data && (
            <>
              {data?.map((v, i) => (
                <div className="col-md-6" key={`_olevel_sitting_${i}`}>
                  <div className="card text-center border border-success">
                    <div className="card-header">{v?.examinationtype}</div>
                    <div className="card-body">
                      <h5 className="card-title">{v?.examinationnumber}</h5>
                      <p className="card-text">{v?.examinationcenter}</p>
                      <p className="card-text">{v?.examinationyear}</p>
                      <div className="d-flex justify-content-center ">
                        <BtnOLevel modules={v} key={`oLevel_${i}`} />
                        <div className="p-1"></div>
                        <BtnDeleteOLevel modules={v} key={`oLevel_del_${i}`} />
                      </div>
                    </div>
                    <div className="card-footer text-body-secondary">{moment(v.createdAt)} ago</div>
                  </div>
                </div>
              ))}
            </>
          )}
        </div>
      )}
      <BtnOLevel />
    </>
  );
};

export default OLevel;
